import {
  getState,
  formSelector,
  updateForm,
  onlyIfAutoForm,
  useSelector,
} from '../../../../store.js'
import api from '../../../../common/api.js'
import {isPresent} from '../../../../common/utils.js'
import {NEW_ID} from '../../../../common/constants/index.js'
import {SENDLE} from '../../../../common/constants/ShipperNames.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import ButtonSecondary from '../../../../common/components/Button/ButtonSecondary.js'
import {setShipper} from '../../../../data/shippers.js'
import {showGlobalError} from '../../../GlobalErrorMessage.js'
import Archive from './Archive.js'
import Nickname from './Nickname.js'
import ShippingMethods from './ShippingMethods.js'
import {
  baseSaveParamsSelector,
  baseShipperFormErrorsSelector,
  baseShipperInitialFormSelector,
  goToShipperSettings,
} from '../ShippersFunctions.js'
import className from '../../../../common/className.js'
import TextInput from '../../Common/TextInput.js'

export function setUpShipperForm({shipper, formName}) {
  return {
    formName,
    initialForm: {
      ...initialFormSelector(getState(), {shipper}),
      errorsSelector,
    },
  }
}

export function errorsSelector(state, {formName}) {
  const errors = baseShipperFormErrorsSelector(state, {formName})
  const form = formSelector(state, {
    formName,
  })

  if (!isPresent(form.sendle_id)) {
    errors.sendle_id = 'Sendle ID is required'
    errors.preventSave = true
  }

  if (!isPresent(form.api_key)) {
    errors.api_key = 'API ID is required'
    errors.preventSave = true
  }

  return errors
}

export function initialFormSelector(state, {shipper}) {
  const vendorConfig = shipper?.vendor_config || {}

  return {
    ...baseShipperInitialFormSelector(state, {shipper, vendor: SENDLE}),
    sendle_id: vendorConfig.sendle_id || '',
    api_key: vendorConfig.api_key || '',
    isSaving: false,
  }
}

export async function saveShipperSendle(formName) {
  const form = formSelector(getState(), {formName})
  let [shipperID, params] = baseSaveParamsSelector(getState(), {formName})

  const {sendle_id, api_key} = form

  params = {
    ...params,
    sendle_id,
    api_key,
  }

  updateForm(formName, {isSaving: true})

  try {
    const {json} = await (shipperID !== NEW_ID
      ? api.put(`/shipper/${shipperID}/`, params)
      : api.post('/shipper/', {...params, vendor: SENDLE}))

    goToShipperSettings()

    setShipper(json)
  } catch (err) {
    showGlobalError(
      {
        summary: 'There was an error while saving shipper.',
        details: err.error_message || err.message,
      },
      err,
    )

    updateForm(formName, {isSaving: false})
  }
}

function SendleForm({formName, form}) {
  const {id, sendle_id, api_key, isSaving} = form
  const errors = useSelector((state) => form.errorsSelector(state, {formName}))

  return (
    <div className="settings-list-item-form-wrap clear-both">
      <div className="medium-6 columns">
        <fieldset>
          <ul className="form-list margin-bottom-0">
            {id !== NEW_ID && <Nickname formName={formName} />}
            <li
              className={className`form-list-item bigger margin-bottom-20 ${{'margin-top-20 divider--top': form.id !== NEW_ID}}`}
            >
              <TextInput
                label="Sendle ID"
                name="sendle_id"
                value={sendle_id}
                onChange={(event) =>
                  updateForm(formName, {
                    sendle_id: event.target.value,
                    hasChanged_sendle_id: true,
                  })
                }
                errorMessage={form.hasChanged_sendle_id && errors.sendle_id}
                required
              />
            </li>
            <li className="form-list-item bigger margin-bottom-20">
              <TextInput
                label="API Key"
                name="api_key"
                value={api_key}
                onChange={(event) =>
                  updateForm(formName, {
                    api_key: event.target.value,
                    hasChanged_api_key: true,
                  })
                }
                errorMessage={form.hasChanged_api_key && errors.api_key}
                required
              />
            </li>
            {id !== NEW_ID && <ShippingMethods formName={formName} />}
            <li className="list__item list__item--no-style">
              <ButtonPrimary
                onClick={() => saveShipperSendle(formName)}
                isDisabled={errors.preventSave}
                isLoading={isSaving}
              >
                {id !== NEW_ID ? 'Save' : 'Create'}
              </ButtonPrimary>
              <ButtonSecondary onClick={() => goToShipperSettings()}>
                Cancel
              </ButtonSecondary>
            </li>
          </ul>
        </fieldset>
      </div>
      <div className="medium-5 columns">
        <fieldset>
          <div className="alert margin-bottom-10 alert--standard">
            {id === NEW_ID ? (
              <dl className="list">
                <dt className="list__title fs-00 lh-md margin-bottom-5">
                  Need help setting up your Sendle account?
                </dt>
                <dd className="list__item fs-n0 margin-bottom-0">
                  Please contact{' '}
                  <a href="mailto:support@ordoro.com">support@ordoro.com</a> to
                  have this special shipper enabled in your account.
                  <div>
                    <a
                      className="btn--link mid meta-ups-setup-help"
                      href="https://support.ordoro.com/how-do-i-set-up-sendle-in-ordoro/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      More info →
                    </a>
                  </div>
                </dd>
              </dl>
            ) : (
              <Archive formName={formName} />
            )}
          </div>
        </fieldset>
      </div>
    </div>
  )
}

export default onlyIfAutoForm(SendleForm, setUpShipperForm)
